<template>
    <div class="sports">
        <pTitle :msg="msg"></pTitle>
        <div class="sport_list">
            <div class="sports_title">
                <p>赛&#x3000;&#x3000;事</p>
                <p>SPORTS</p>
            </div>
            <div class="game_list">
                <ul>
                    <li @click="handleGame">
                        <div :style="{'display':'flex','align-items': 'center'}">
                            <div :style="{'flex': '1.5'}">2024年全国羽阿啊撒大声地啊萨德阿萨德阿萨德阿是毛球锦标赛</div>
                            <div><i class="iconfont icon-shijian color_bg"></i><span>2023-05-07</span></div>
                            <div>
                                <i class="iconfont icon-icon_location color_bg"></i>
                                <span>奥体中心体育馆</span>
                            </div>
                            <div :style="{'flex': '0.5'}">进行中</div>
                        </div>
                    </li>
                    <li>
                        <div :style="{'display':'flex','align-items': 'center'}">
                            <div :style="{'flex': '1.5'}">2024年全国羽毛球锦标赛</div>
                            <div><i class="iconfont icon-shijian color_bg"></i><span>2023-05-07-</span></div>
                            <div>
                                <i class="iconfont icon-icon_location color_bg"></i>
                                <span>奥体中心体育馆ff阿萨德阿萨德</span>
                            </div>
                            <div :style="{'flex': '0.5'}">进行中</div>
                        </div>
                    </li>
                    <li>
                        <div :style="{'display':'flex','align-items': 'center'}">
                            <div :style="{'flex': '1.5'}">2024年全国羽毛球锦标赛</div>
                            <div><i class="iconfont icon-shijian color_bg"></i><span>2023-05-07</span></div>
                            <div>
                                <i class="iconfont icon-icon_location color_bg"></i>
                                <span>奥育馆</span>
                            </div>
                            <div :style="{'flex': '0.5'}">进中</div>
                        </div>
                    </li>
                    
                </ul>
            </div>

        </div>
  
      
    </div>
  </template>
  
  <script>
  import pTitle from "@/components/pTitle.vue";
  import sportList from '@/assets/common/SportList.json';
  import axios from 'axios';
  import http from '@/assets/js/http.js';
  // import lazy from'@/assets/js/element-lazy.js';
  import Vue from "vue";
  import { Lazyload,Toast } from "vant";
  Vue.use(Lazyload,Toast);
  // 注册时可以配置额外的选项
  Vue.use(Lazyload, {
    lazyComponent: true,
  });
  export default {
    name: "mHome",
    components: {
        pTitle,
    },
    data() {
      return {
        msg: "PC端羽毛球成绩网站",
        // images: [
        //   "https://img01.yzcdn.cn/vant/apple-1.jpg",
        //   "https://img01.yzcdn.cn/vant/apple-2.jpg",
        //   "https://img01.yzcdn.cn/vant/apple-3.jpg",
        //   "https://img01.yzcdn.cn/vant/apple-4.jpg",
        // ],
        images: [
        // require("@/assets/img/banner2.jpg"),
            require("@/assets/img/banner1.png"),
            require("@/assets/img/banner2.png"),
            require("@/assets/img/banner7.jpg"),
            // require("@/assets/img/banner0.png"),
        ],
        monthVal: '',
        sportList: {},
        currentPage: 0, // 当前页面的索引值
        pageSize: 3, // 每次加载的数据数量
        listEmpty: [],
        listAllarr: [],
        num: 2,
        dom: null,
        sportListNew:[],
      };
    },
    mounted() {
      http.GetFile('/Sports/BDM/SportList.json?v='+Math.random()).then(res=>{//获取赛事列表地址
          console.log(res)
          this.sportListNew = res.JsonData;
          this.sportList = res;
      })
      
        
    },
    methods: {
      handleGame(item){//点击赛事列表逻辑
        console.log(item);
        
        if(item.StatusCode < 50){
          // Toast({
          //     message:item.StatusName,
          //     duration:1000
          // });
        }else{
          // this.$router.push('/Live');
          // 生成随机数
          let randomNum = Math.random(); // 这里的范围根据需求进行调整
          this.$router.push({
                path: '/Games', 
                query: { v: randomNum }
          });
  
          sessionStorage.setItem('PCSportCode',item.SportCode)
          sessionStorage.setItem('PCSportName',item.SportName)
        }
      },
      changeMonth(){//月份筛选
        this.sportListNew = this.sportList.JsonData;
        this.monthVal== null ?this.monthVal='': this.monthVal;
        // console.log(this.monthVal);
        let newArr = [];
        let monthVal = this.monthVal
  
        if(monthVal !='' ){
          newArr = this.sportListNew.filter(function(el){
            return el.BeginDate.includes(monthVal)
          })
          console.log(newArr);
          this.sportListNew = newArr;
        }else{
          // console.log()
          this.sportListNew = this.sportList.JsonData;
        }
        // this.activities.forEach(el => {
        //   // console.log(el);
        //   if(el.BeginDate.indexOf(this.monthVal)){
        //     console.log(el)
        //   }
        // });
      },
  
  
      /**
       * 懒加载逻辑-完成
       * */ 
      throttle(fn, wait) {
        // console.log(fn);
        // console.log(wait);
        //闭包节流
        let timer = "";
        return function (...args) {
          if (timer) return;
          timer = setTimeout(() => {
            timer = null;
            fn.apply(this, args);
          }, wait);
        };
      },
      getData(id, lazyLoadObser, lazyImage) {
        // console.log("加载", id);
        // console.log("2", lazyLoadObser);
        // console.log("3载", lazyImage);
        //解绑监听事件
        // console.log(document.getElementsByClassName(id))
        lazyLoadObser.unobserve(lazyImage);
        document.getElementsByClassName(id)[0].style = "transform:translate(0px)";
        //   this.$set(this.activities[id], ".listbox", "b");
      },
      /**
       * 懒加载逻辑结束
       * */
  
  
      /**
       * 懒加载逻辑-写一半方法
       * */
      loadMoreData() {
        this.listAllarr = this.activities;
        this.num = 2;
        this.listEmpty = [];
  
        if (this.listAllarr.length > 2) {
          for (let i = 0; i < 3; i++) {
            this.listEmpty[i] = this.listAllarr[i];
          }
        } else {
          this.listEmpty = this.listAllarr;
        }
      },
      ladzyloding() {
        let dom = document.querySelector(".listWrapper");
  
        console.log(dom.scrollHeight);
        console.log(dom.scrollTop);
        console.log(dom.clientHeight);
        window.addEventListener("scroll", (v) => {
          var pagescrollTop =
            document.documentElement.scrollTop || document.body.scrollTop;
          // console.log(pagescrollTop)
          const scrollDistance =
            dom.scrollHeight - dom.scrollTop - dom.clientHeight;
          console.log("鼠标移动:", scrollDistance);
          if (scrollDistance <= 1) {
            //0等于到底了
            //一条一条加载数据，直至遍历到最后一条
            while (this.num < this.listAllarr.length) {
              this.listEmpty[this.num] = this.listAllarr[this.num];
              // this.listEmpty.push(this.listAllarr[this.num])
              console.log(this.listEmpty);
              this.$forceUpdate();
              this.num++;
              // console.log(this.num)
            }
          }
        });
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
    $color: #3641C9;
    .sport_list{
        width: 1400px;
        background: rgba(255,255,255,0.8);
        margin: 30px auto;
        border-radius: 10px;
        box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.5);
        // padding: 20px;
    }
    .sports_title{
        // width: 100%;
        text-align: center;
        padding: 10px;
        border-bottom: 1px solid $color;
        font-size: 30px;
        color: $color;
    }
    .game_list{
        width: 1000px;
        margin: 0 auto;
        padding: 35px 10px;
        li{
            padding: 15px;
            border-bottom: 2px solid;
            border-image: radial-gradient(circle,  #71B8E8,white);
            border-image-slice: 1;
            list-style: circle;
            font-size: 18px;
            color: $color;
            div{
                flex: 1;
                span{
                    margin-left: 5px;
                }
            }
        }
        li>div{
            color: #333;
        }
    }
    .color_bg{
        color: $color;
    }
  </style>